import { useNavigate } from 'react-router-dom';

import { PATHS } from '@/shared/constants/routes/paths';
import { useInterfaceLanguage } from '@/shared/i18n';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LightningIcon } from '../icons';
import { SButton, SIcon } from './styled';

type ViewPlansButtonProps = {
  onNavigate?: () => void;
};

export const ViewPlansButton = ({ onNavigate }: ViewPlansButtonProps) => {
  const { t } = useInterfaceLanguage();
  const navigate = useNavigate();

  const handleViewPlans = () => {
    MixpanelEvents.viewPlansSidebarClick();
    navigate(`/${PATHS.pricing}`, { state: { pricingEntryPoint: 'sidebar_view_plans' } });
    onNavigate?.();
  };

  return (
    <SButton data-testid="sidebar-view-plans" onClick={handleViewPlans}>
      <SIcon aria-hidden>
        <LightningIcon height={17} width={17} />
      </SIcon>
      {t('sidebar.viewPlans')}
    </SButton>
  );
};
